import { Panel } from '../../../common/panel'
import { PreRender } from './PreRender'
import './i18n'

export const OrderManagement = () => {
  return (
    <Panel isI18n label="userManagement.orderManagement.ORDER_MANAGEMENT">
      <PreRender />
    </Panel>
  )
}
